<template>
  <div>
    <div class="left">
      <google-map v-if="isRenderLeaflet"/>
    </div>
    <div class="right">
      <vehicle v-show="!isViewHistoryDetail"/>
      <history-detail v-if="isViewHistoryDetail"/>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
import Vehicle from '@/pages/vehicle/components/List';
import GoogleMap from '@/pages/map/components/map';
import HistoryDetail from '@/pages/map/components/historydetail';
import { mapGetters, mapMutations, mapActions } from 'vuex';

if (this.$leaflet) {
    
  window.L = this.$leaflet;
}


export default {
  components: {
    Vehicle,
    GoogleMap,
    HistoryDetail
  },

  data: () => ({
    isRenderLeaflet: false
  }),

  computed: {
    ...mapGetters(['isViewHistoryDetail'])
  },

  async created () {
    let accessTokenFromQuery = this.$route.query.accessToken;
    let refreshTokenFromQuery = this.$route.query.refreshToken;

    if (accessTokenFromQuery) {
      let token = {
        access_token: accessTokenFromQuery,
        refresh_token: refreshTokenFromQuery
      };
      this.SET_TOKEN(token);
      await this.getVehicles().then(res => {
        setTimeout(async () => {
          this.getUserInfo().then(_ => {
            window.location.href = '/';
          });
        }, 100);
      }).catch(_ => {
        setTimeout(() => {
          this.getUserInfo().then(_ => {
            window.location.href = '/';
          });
        }, 100);
      });
      setTimeout(() => {
        this.getUserInfo().then(_ => {
          window.location.href = '/';
        });
      }, 500);
    }
    setTimeout(() => {
      this.isRenderLeaflet = true;
    }, 1000); // Settimeout tạm thời -> xử lý việc leaflet.markercluster load trước leaflet
  },

  methods: {
    ...mapMutations([
      'SET_TOKEN'
    ]),
    ...mapActions([
      'getUserInfo',
      'getVehicles'
    ])
  }
};
</script>
<style scoped>
.left {
  width: calc(100% - 400px);
  height: calc(100vh - 64px);
}
.right {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/pages/map/index.vue